<template>
  <div class="row">
    <div class="col-8 h-100">
      <breadcrumb :page="page" />
    </div>
    <div v-if="hasPermission" class="col-4 text-right">
      <ActionButton
        id="btnPeiDefinition"
        i="fas fa-paste"
        variant="success"
        class="pr-2"
        @click="canDefinePeiPs"
      >
        Definir PEI
      </ActionButton>
    </div>
    <div class="col-12">
      <div class="dropdown-divider mt-0 pb-2 w-100" />
      <StudentHistory />
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/common/page/TitleBreadcrumb';
import StudentHistory from '@/components/pei/PeiHistory';
import store from '@/store/index';
import mixAlert from '@/mixin/alert.mixin';
import router from '@/router/index';
import { ActionButton } from '@/components/common';

export default {
  name: 'History',
  mixins: [mixAlert],
  components: {
    StudentHistory: StudentHistory,
    breadcrumb,
    ActionButton,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-history',
        title: 'Historial de PEI',
        routes: ['Inicio', 'PEI', 'Historial del Estudiante'],
      },
    };
  },
  methods: {
    goMenu() {
      router.push({ path: '/pei/Menu' });
    },
    async canDefinePeiPs() {
      let self = this;
      let tabValidations = {
        validation: false,
      };
      store.commit('setPeiValidationTriggered', tabValidations);
      await self
        .$ApiGet(
          `/api/pei/studentcandefinepeips?studentSieId=${self.$store.getters.SelectedStudent.studentId}`
        )
        .then(() => router.push({ path: '/pei/definition' }))
        .catch((error) => {
          self.ShowAlertModal('Atención', error.response.data.message, null);
        });
    },
  },
  computed: {
    hasPermission() {
      return store.getters.HasPermission('pei.create');
    },
  },
};
</script>

<style scoped>
#btnPeiDefinition {
  color: white;
  width: auto;
}
#btnPeiDefinition:hover {
  text-decoration: none;
}
.h-100 {
  height: 100px !important;
}
/*end of text for navigation*/
/***Transparent button for dropdown***/
.btn-transparent {
  background: transparent;
}
.btn-green {
  background: #2db782;
  color: white;
  font-weight: 400;
}
.btn-green:hover {
  color: white;
  text-decoration: none;
}
.border-green {
  border: solid 1px #2db782;
  color: #2db782;
}
.border-green:focus {
  outline: 0;
  box-shadow: none;
}
.dropdown-menu {
  min-width: 9rem;
  padding: 0.5rem 0em;
}
.define-pei-container {
  padding-right: 35px;
}
/***End of Transparent button***/
</style>
